<div class="w-fit place-items-center rounded-2xl border-4 border-emerald-500 bg-emerald-50 p-4">
  <div class="relative grid h-27 w-68 grid-cols-5 gap-2 gap-y-3">
    @if (fixedEggs(); as fixed) {
      @for (_ of [].constructor(fixed); track $index) {
        <div
          [style.background]="fixedFillColor()"
          animate.enter="anim-pop-in"
          animate.leave="anim-pop-out"
          class="z-10 size-12 rounded-full"
          data-test-id="filled-egg"
        ></div>
      }
    }

    @let leftover = eggs() - fixedEggs();
    @if (leftover > 0) {
      @for (_ of [].constructor(leftover); track $index) {
        <button
          (click)="changeable() && eggs.set($index + 1)"
          [class.cursor-pointer]="changeable()"
          [style.background]="fillColor()"
          animate.enter="anim-pop-in"
          animate.leave="anim-pop-out"
          class="z-10 size-12 rounded-full"
          data-test-id="filled-egg"
        ></button>
      }
    }

    <div class="absolute inset-0 grid grid-cols-5 gap-2 gap-y-3">
      @for (_ of [].constructor(10); track $index) {
        <button
          (click)="changeable() && eggs.set($index + 1)"
          [class.cursor-pointer]="changeable()"
          class="size-12 rounded-full border-4 border-emerald-500"
          data-test-id="empty-egg"
        ></button>
      }
    </div>
  </div>
</div>
